import * as CryptoJS from 'crypto-js';


export enum AroFloZone {
    Task = 'tasks',
    TaskNotes = 'tasknotes',
    TaskExpense = 'expenses',
    DocumentsPhotos = 'documentsandphotos',
    CustomFields = 'customfields',
    Assets = 'assets',
    Schedules = 'schedules',
    Invoices = 'invoices',
    //SHIT AROFLO API
    TaskJoin = 'task'
}

export enum AroFloWhereOperator {
    Equal = '=',
    NotEqual = '!=',
    GreaterThan = '>',
    GreaterThanEq = '>=',
    LessThan = '<',
    In = 'IN',
    NotIn = 'NOT IN',
}

export enum AroFloLogicalOperator {
    And = 'and',
    Or = 'or'
}

export interface AroFloCredentials {
    uEncoded: string;
    pEncoded: string;
    orgEncoded: string;
    secret: string;
}

export interface AroFloWhereCondition {
    propertyName: string;
    operator: AroFloWhereOperator;
    value: any;
}

export interface AroFloRequest {
    url: string;
    headers: any;
}

export enum AroFloHeaders {
    RateLimitRemaining = 'x-ratelimit-remaining',
    RateLimitDailyRemaining = 'x-ratelimit-daily-remaining',
    RateLimitSecondaryDailyRemaining = 'x-ratelimit-secondary-daily-remaining',
    Status = 'statuscode'
}

export interface AroFloHeaderValues {
    remaining: number;
    dailyRemaining: number;
    secondaryDailyRemaining: number;
    status: AroFloStatusCodes;

}

export enum AroFloStatusCodes {
    Success = 0,
    AuthFailed = -99999,
    LoginFailedRequest = 1,
    LoginFailedInvalid = 2,
    LoginFailedPermission = 3,
    LoginFailedAPI = 4,
    InvalidRequest = 5,
    RateLimitMinuteOrSecondsExceeded = 6,
    RateLimitDailyExceeded = 7,
    PayloadSizeExceeded = 8
}

export class AroFloRequestUtility {
    private static readonly _baseUrl = 'https://api.aroflo.com';

    public static buildGetRequest(credentials: AroFloCredentials, zone: AroFloZone, joins: AroFloZone[], whereClause: string[], pageNumber: number = 1): AroFloRequest {
        let request = `zone=${encodeURIComponent(zone)}`;
        if (joins.length) {
            request += `&join=${encodeURIComponent(joins.join(','))}`;
        }

        if (whereClause.length) {
            whereClause.forEach((clause, wi) => {
                request += `&where=${encodeURIComponent(clause)}`;
            });
        }

        request += `&page=${encodeURIComponent(pageNumber)}`;

        const headers = AroFloRequestUtility.buildArofloHeaders(credentials, 'GET', request);

        return {
            url: `${this._baseUrl}?${request}`,
            headers: headers
        } as AroFloRequest;
    }


    private static buildArofloHeaders(credentials: AroFloCredentials, requestType: string, urlVarString: string): any {
        const isoDate = new Date().toISOString();
        //we dont do host ip
        const urlPath = '';
        const accept = 'text/json';
        const auth = `uencoded=${encodeURIComponent(credentials.uEncoded)}&pencoded=${encodeURIComponent(credentials.pEncoded)}&orgEncoded=${encodeURIComponent(credentials.orgEncoded)}`;

        const payload = [requestType];
        payload.push(urlPath);
        payload.push(accept);
        payload.push(auth);
        payload.push(isoDate);
        payload.push(urlVarString);

        //Create a hash of the payload
        const hash = CryptoJS.HmacSHA512(payload.join('+'), credentials.secret);
        return {
            urlPath: urlPath,
            accept: accept,
            Authorization: auth,
            Authentication: 'HMAC ' + hash.toString(),
            af_hmac_signature: hash.toString(),
            afdatetimeutc: isoDate
        };
    }


    public static buildWhereClause(conditions: AroFloWhereCondition[], logicalOperator: AroFloLogicalOperator = AroFloLogicalOperator.And): string[] {
        const clauses = [];
        conditions.forEach((condition, index) => {
            let whereClause = '';
            whereClause += logicalOperator === AroFloLogicalOperator.And ? 'and|' : 'or|';
            //The value property of the condition might be an array of values
            //If it is, we need to turn it into a string separated by the * character
            let valueString = '';
            if (condition.value instanceof Array) {
                condition.value.forEach((value, i) => {
                    valueString += value;
                    if (i < condition.value.length - 1) {
                        valueString += '*';
                    }
                });
            }
            else {
                valueString = condition.value;
            }

            whereClause += `${condition.propertyName}|${condition.operator}|${valueString}`;
            // if (index < conditions.length - 1) {
            //     whereClause += '|';
            // }
            clauses.push(whereClause);
        });

        return clauses;
    }

    public static readHeaders(headers: any): AroFloHeaderValues {
        const values: AroFloHeaderValues = {
            remaining: parseInt(headers[AroFloHeaders.RateLimitRemaining] ?? 0),
            dailyRemaining: parseInt(headers[AroFloHeaders.RateLimitDailyRemaining] ?? 0),
            secondaryDailyRemaining: parseInt(headers[AroFloHeaders.RateLimitSecondaryDailyRemaining] ?? 0),
            status: parseInt(headers[AroFloHeaders.Status] ?? AroFloStatusCodes.AuthFailed)
        };
        return values;
    }

}

